import axios from "axios" 
import { urlAdmin } from "../../urlAdminApi/urlAdmin"

export const loginAdmin =  async (id, password) => {
  return await axios.post(`${urlAdmin}cust_cab/login`, {"id": id, "password": password}, {headers: {
    'Content-Type': 'application/json'
  }})
} 